import { render, staticRenderFns } from "./CampaignControls.vue?vue&type=template&id=187cf242&"
import script from "./CampaignControls.vue?vue&type=script&lang=js&"
export * from "./CampaignControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports